customElements.component = 'section-header';

if (!customElements.get(customElements.component)) {
  const selectors = {
    header: '.js-header',
    transparent: 'header--transparent',
    scrolled: 'header--scrolled',
  };

  class Header extends HTMLElement {
    constructor() {
      super();

      this.body = document.querySelector('body');
      this.header = this.querySelector(selectors.header);
      this.isHeaderTransparent = this.getAttribute('data-is-header-transparent');
      
      this.updateHeaderHeight();

      if (this.isHeaderTransparent) {
        this.body.classList.add(selectors.transparent);

        this.handleScroll = this.handleScroll.bind(this);

        this.handleScroll();

        window.addEventListener('scroll', this.handleScroll);
      }

      // Debounced resize handler
      let resizeTimeout;
      this.handleResize = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          this.updateHeaderHeight();
        }, 250);
      };

      window.addEventListener('resize', this.handleResize);
    }

    updateHeaderHeight() {
      const headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    }

    handleScroll() {
      if (window.scrollY >= 40) {
        this.body.classList.add(selectors.scrolled);
        this.updateHeaderHeight();
      } else {
        this.body.classList.remove(selectors.scrolled);
        this.updateHeaderHeight();
      }
    }
  }

  customElements.define(customElements.component, Header);
}